/**
* @author 阿佑[ayooooo@petalmail.com]
* @date 2022/4/16 18:34
* @description
*   OnlyApp.vue of WeTrade
*/
<template>
<component :is="tag" @click.capture="check">
  <slot />
</component>
</template>

<script lang="ts">
import { openDialog } from '@/components/popup/popup'
import GetApp from '@/pages/GetApp.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OnlyApp',
  props: {
    tag: {
      type: [String, Object, Function],
      default: 'div',
    },
  },
  setup () {
    return {
      check (e: MouseEvent) {
        e.stopPropagation()

        openDialog(GetApp, null, {
          wrapperClass: 'operation',
        })
      },
    }
  },
})
</script>
